module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAAAXNSR0IArs4c6QAAASVJREFUOBGllL2OgkAQx12goLlSn+ESSysb77wHoYDH4qPgQSSxsbK8hGfQ8hoKPtzfnksQl8XESSAw858fO7OzLBbSuq4TcRx/p2n6wfsrhpYcctE73JIk+Wrbtmia5pRl2RKfzdCgJYdctArkOM5ZCPEr6eu6rgsbjBgatOSQ24OiKPrzPG8/BxtDyCEXkKqPB8wkDMPwOhcj/gCaSsA/LIeV6A8Qw55AOEcrK/HJnnxSuglC3AgicIcdASihEKWE7MYrIYapXft/fO9uBA1Ko5ySi5XZRuMJNICoOaEcrrnReOiRAdLvji1GU3rQnBCxTaNAHEDOjh77qS0Gluf5qqqqg9a6rrtlulWP5OHb6IANAigIgovv+z+6Z+TiVyYhb/9GbhjbKhW53q7kAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close1@2x.png
// module id = 5J0b
// module chunks = 1